import { useEffect } from 'react'

import { useProductStoreActions } from '@/modules/product/stores/product.store'
import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import { HttpStatusCode } from '@/modules/shared/protocols/http-client.protocol'
import { isJSON } from '@/modules/shared/utils/general-helper'
import { useOrderFormCalculation } from '../../../hooks/use-order-form-calculation.hook'
import { useOrderFormStoreActions } from '../../../stores/order-form.store'
import { useOrderFormComponentStoreActions } from '../../../stores/order-form-component.store'
import { modalLoadExcelService, type TModalLoadExcelService } from '../../../services/modal-load-excel.service'


export const useModalLoadExcelComponentData = () => {
  const { setProducts } = useProductStoreActions

	const {calculateOrderForm} = useOrderFormCalculation()
  const { setJsonOrderForm, setIsCalculationOrder } = useOrderFormStoreActions()
  const { setIsOpenModalLoadExcel } = useOrderFormComponentStoreActions

  const { axiosRequest: requestLoadExcel } = useAxiosHttpClient({
    sendRequest: modalLoadExcelService,
  })

  const handleSubmitRequest = ({ payload }: TModalLoadExcelService) => {
    requestLoadExcel.mutate({
      payload,
      showInfo: true,
      showSuccess: true,
    })
  }

  useEffect(() => {
		if (requestLoadExcel.isSuccess) {
			if (requestLoadExcel.data.status === HttpStatusCode.OK) {
				const responseParsed = JSON.parse(requestLoadExcel.data.body)

        setProducts(undefined)
        setIsCalculationOrder(false)
        setIsOpenModalLoadExcel(false)
        setJsonOrderForm(responseParsed)

				calculateOrderForm(responseParsed);
        return
      }

      if (requestLoadExcel.data.status === HttpStatusCode.NO_CONTENT) {
        if (requestLoadExcel.data.message.includes('Planilha fora')) {
          return
        }

        const hasValues = isJSON(requestLoadExcel.data.body)

        if (hasValues) {
          const responseParsed = JSON.parse(requestLoadExcel.data.body)

          setProducts(undefined)
          setIsCalculationOrder(false)
          setIsOpenModalLoadExcel(false)
          setJsonOrderForm(responseParsed)
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestLoadExcel.isSuccess])

  return {
    state: {
      isLoadingRequest: requestLoadExcel.isLoading,
    },
    action: {
      onSubmitRequest: handleSubmitRequest,
    },
  }
}
